import { FormItem } from '@eastcoal/formily/components/FormItem'
import { RichEditor } from '@eastcoal/formily/components/RichEditor'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const descriptionSchema: Record<string, SchemaItem> = {
  description: {
    type: 'string',
    'x-decorator': FormItem,
    'x-component': RichEditor,
    'x-decorator-props': {
      inset: true
    }
  }
}
